import { localStorageSync } from 'ngrx-store-localstorage'
import { MetaReducer } from "@ngrx/store";
import * as CryptoJS from 'crypto-js';

// Secret key for encryption (you should keep this safe)
const encryptionKey = 'your-secret-key';

// Custom serialize function: Encrypt the state
function encryptState(state: any): any {
    const stateString = JSON.stringify(state);
    const encryptedState = CryptoJS.AES.encrypt(stateString, encryptionKey).toString();
    return encryptedState;
}

// Custom deserialize function: Decrypt the state
function decryptState(encryptedState: string): any {
    const bytes = CryptoJS.AES.decrypt(encryptedState, encryptionKey);
    const decryptedState = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decryptedState);
}

// Sync state to localStorage
export function localStorageSyncReducer(reducer: any): any {
    return localStorageSync({
        keys: [
            {
                auth: {
                    serialize: (state: any) => encryptState(state),
                    deserialize: (state: string) => decryptState(state)
                }
            }
        ], // Specify which slices of state to persist
        rehydrate: true, // Rehydrate the state on load
    })(reducer);
}

export const metaReducers: MetaReducer[] = [localStorageSyncReducer];